export const IManage = {
  "title": "iManage 10",
  "getFilePickerUrlError": "Service unavailable. Please try again later.",
  "tokenExpired": "Token expired, please login again"
}